module.exports = __webpack_public_path__ + "img/wf-finishing-position-28.7bd95aa3.svg";